import { render } from "./importConfig.vue?vue&type=template&id=dda17ff4&ts=true"
import script from "./importConfig.vue?vue&type=script&lang=ts"
export * from "./importConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__